<template>
    <div>
        <span class="ssv-summry-price-box__title">{{voucher ? 'Cena po slevě:' : 'Cena celkem:'}}</span><br>
        <span class="ssv-summry-price-box__price">{{calculatePrice()}} Kč</span>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name:     'SsvOrderPriceCalculation',
    computed: {
        ...mapGetters('ssvOrder', ['course', 'numberOfParticipants', 'voucher', 'type', 'numberOfBooks'])
    },
    methods:  {
        calculatePrice() {
            let price = 0;
            const { priceVat, priceForNumberOfParticipants } = this.course;
            if (this.type.code === 500) {
                price = priceVat * this.numberOfBooks;
            } else {
                if (priceForNumberOfParticipants > 1) {
                    price = priceVat;
                } else {
                    price = priceVat * this.numberOfParticipants;
                }
            }

            if (this.voucher) {
                const { percentageDiscount, priceDiscount } = this.voucher;
                if (percentageDiscount) {
                    const onePercent = price / 100;
                    price = price - (onePercent * percentageDiscount);
                } else if (priceDiscount) {
                    price = price - priceDiscount;
                    if (price < 0) price = 0;
                }
            }

            return price.toFixed(0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/price/PriceCalculation.vue